export const initialState = {
  name: '',
  number: '',
  filter: '',
};
